module.exports = __webpack_public_path__ + "img/play-button.8beebd1460cefeee0de25b573302edf9.svg";